import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportBuilderTypeSelector',
  props: {
    value: {
      type: String as () => 'lumiform' | 'word',
      required: true,
    },
  },
  emits: ['input'],
  setup(__props, { emit }) {

  

  

  const selectType = (type: 'lumiform' | 'word') => {
    emit('input', type);
  };

return { __sfc: true,emit, selectType }
}

})